var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',[_c('search'),_c('workSheetTable',{ref:"workSheetTableRef",attrs:{"tableColumns":_vm.tableColumns,"status":_vm.status}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }